// extracted by mini-css-extract-plugin
module.exports = {"mobileWhatsappIcon":"WhatsappButtonStyles_mobileWhatsappIcon__1O92n"};